// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"17c878de","289":"b505cba0","395":"eb1df248","397":"1abe34ee","454":"bbade3e6","525":"c00c0084","670":"cefac047","674":"7911fa56","685":"dee658f6","850":"d7aaebda","852":"c4898b84","858":"dc8fd788","883":"467f763b","944":"cdc6fcd1","975":"dc1323af"}[chunkId] + ".chunk.js";
};